import React from "react";

import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import { Checkbox, ListItemText } from "@material-ui/core";
import { i18n } from "../../translate/i18n";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  menuListItem: {
    paddingTop: 0,
    paddingBottom: 0,
  },
  menuItem: {
    maxHeight: 30,
  },
  queueSelectContainer: {
    minWidth: 120,
    maxWidth: 200,
    width: '100%',
    marginTop: -4,
    [theme.breakpoints.down('sm')]: {
      minWidth: 100,
      maxWidth: 150,
    },
  },
}));

const TicketsQueueSelect = ({
  userQueues,
  queues,
  selectedQueueIds = [],
  onChange,
}) => {
  const classes = useStyles();
  const queueList = Array.isArray(queues)
    ? queues
    : Array.isArray(userQueues)
      ? userQueues
      : [];
  const selectedQueueIdSet = new Set(selectedQueueIds.map((queueId) => String(queueId)));
  const selectedQueues = queueList.filter((queue) =>
    queue?.id !== undefined && selectedQueueIdSet.has(String(queue.id))
  );

  const handleChange = (e) => {
    onChange(e.target.value);
  };

  const renderSelectedValue = () => {
    if (!selectedQueueIds.length) {
      return i18n.t("ticketsQueueSelect.placeholder");
    }

    const selectedNames = selectedQueues
      .map((queue) => queue.name)
      .filter(Boolean);

    if (!selectedNames.length) {
      return `${selectedQueueIds.length} filas selecionadas`;
    }

    if (selectedNames.length <= 2) {
      return selectedNames.join(", ");
    }

    return `${selectedNames.slice(0, 2).join(", ")} +${selectedNames.length - 2}`;
  };

  return (
    <div className={classes.queueSelectContainer}>
      <FormControl fullWidth margin="dense">
        <Select
          multiple
          displayEmpty
          variant="outlined"
          value={selectedQueueIds}
          onChange={handleChange}
          style={{
            borderRadius: 8,
            height: 30,
          }}
          MenuProps={{
            anchorOrigin: {
              vertical: "bottom",
              horizontal: "center",
            },
            transformOrigin: {
              vertical: "top",
              horizontal: "center",
            },
            getContentAnchorEl: null,
            PaperProps: {
              style: {
                borderRadius: "0 0 8px 8px",
              },
            },
            MenuListProps: {
              className: classes.menuListItem,
            },
          }}
          renderValue={renderSelectedValue}
        >
          {queueList?.length > 0 &&
            [...queueList]
              .sort((a, b) => {
                const nameA = String(a?.name || "");
                const nameB = String(b?.name || "");
                return nameA.localeCompare(nameB, "pt-BR", { sensitivity: "base" });
              })
              .map((queue) => (
                <MenuItem
                  dense
                  key={queue.id}
                  value={queue.id}
                  className={classes.menuItem}
                >
                  <Checkbox
                    style={{
                      color: queue.color,
                    }}
                    size="small"
                    color="primary"
                    checked={queue?.id !== undefined && selectedQueueIdSet.has(String(queue.id))}
                  />
                  <ListItemText
                    primary={queue.name}
                    classes={{ primary: classes.listItemText }}
                  />
                </MenuItem>
              ))}
        </Select>
      </FormControl>
    </div>
  );
};

export default TicketsQueueSelect;
